import { render } from "./ProgressDoughnutChart.vue?vue&type=template&id=23f7b3bd"
import script from "./ProgressDoughnutChart.vue?vue&type=script&lang=js"
export * from "./ProgressDoughnutChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__